
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/tickets",
      function () {
        return require("private-next-pages/dashboard/tickets/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/tickets"])
      });
    }
  